module.exports = __webpack_public_path__ + "img/web_account_info1_1.533fa7e8.png";